<span [innerHTML]="copy"></span>
